import React from "react";
import { Flex } from "@jsq/ds/core";
import { FormTextInput } from "@jsq/ds/forms";
import { SPACING } from "~/styles/variables";
import { Tab } from "../../types";
import TabNameSelector from "../TabNameSelector";

interface Props {
  isEditMode: boolean;
  tabs?: Tab[];
}

const ModalBodyContent: React.FC<Props> = ({ tabs = [] }) => {
  return (
    <Flex
      flexDirection="column"
      gap={SPACING.MEDIUM}
      style={{
        minHeight: "200px",
        padding: SPACING.SMALL,
      }}
    >
      {/* Section Name Field */}
      <FormTextInput
        name="name"
        label="Section Name"
        placeholder="Enter section name"
        maxLength={44}
        data-testid="section-name-input"
        isFullWidth
      />

      {/* Description Field */}
      <FormTextInput
        name="description"
        label="Description"
        placeholder="Enter section description (optional)"
        maxLength={100}
        data-testid="section-description-input"
        isFullWidth
      />

      {/* Tab Name Field */}
      <TabNameSelector
        name="tabName"
        label="Tab Name"
        placeholder="Select or create a tab (optional)"
        tabs={tabs}
        data-testid="section-tab-name-input"
      />
    </Flex>
  );
};

export default ModalBodyContent;
